module.exports = __webpack_public_path__ + "static/media/social-media-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/social-media-icon.svg
// module id = 517
// module chunks = 0